import { type HandledError, type HandledErrorSeverity } from "./handled-error"

type Translate = (key: string, options?: Record<string, unknown>) => string

export interface PresentedHandledError {
  message: string
  description?: string
  type: HandledErrorSeverity
  actionLabel?: string
}

const ACTION_LABEL_KEYS = {
  retry: "errors.actions.retry",
  "restart-login": "errors.actions.restartLogin"
} as const

const OAUTH_HINT_KEY = "errors.oauth.continuationHint"

export const presentHandledError = (
  error: HandledError,
  t: Translate
): PresentedHandledError => {
  const fieldLines = (error.fieldErrors ?? []).map(({ field, message }) =>
    t("errors.fieldDetail", { field, message })
  )
  const descriptionParts = [
    error.code === "oauth_continuation" ? t(OAUTH_HINT_KEY) : undefined,
    error.detail,
    ...fieldLines
  ].filter((part): part is string => !!part)

  const presented: PresentedHandledError = {
    message: t(error.messageKey),
    type: error.severity
  }

  if (descriptionParts.length > 0) {
    presented.description = descriptionParts.join("\n")
  }
  if (error.action) {
    presented.actionLabel = t(ACTION_LABEL_KEYS[error.action.kind])
  }

  return presented
}
